import Estimations from '../../domain/estimations/Estimations';
import { Filter } from '../../domain/Filter';

export enum PlacingEstimationStatus {
    Null,
    Progress
}

export default interface EstimationState {
    estimations: Estimations;
    savedDraftEstimations: Estimations;
    placedEstimations: Estimations;
    searchQuery: string;
    filters: Filter[];
    placingEstimationStatus: PlacingEstimationStatus;
}



// WEBPACK FOOTER //
// ./src/application/estimations/State.ts